/**
 * The reading width of a conversation given more room than it needs: the
 * expanded drawer and a chat standing on a page both hold their messages in
 * this one centred column, because lines wider than this stop being read.
 */
export const CHAT_COLUMN_CLASS = 'mx-auto w-full max-w-190';
